import clsx from "clsx";
import PropTypes from "prop-types";
import * as React from "react";
import css from "./PageLayout.module.css";

const ASIDE_WIDTH_MAP = {
  sm: "asideSm",
  md: "asideMd",
  lg: "asideLg",
};

const PageLayoutRoot = React.forwardRef(
  (
    {
      asidePosition = "start",
      asideWidth = "md",
      className,
      children,
      ...rest
    },
    ref,
  ) => (
    <div
      ref={ref}
      className={clsx(
        css.root,
        css[ASIDE_WIDTH_MAP[asideWidth]],
        asidePosition === "end" && css.end,
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  ),
);

PageLayoutRoot.displayName = "PageLayoutRoot";

PageLayoutRoot.propTypes = {
  asidePosition: PropTypes.oneOf(["start", "end"]),
  asideWidth: PropTypes.oneOf(["sm", "md", "lg"]),
  className: PropTypes.string,
  children: PropTypes.node,
};

const PageLayoutAside = React.forwardRef(
  (
    { sticky = true, as: Component = "aside", className, children, ...rest },
    ref,
  ) => (
    <Component
      ref={ref}
      className={clsx(css.aside, sticky && css.sticky, className)}
      {...rest}
    >
      {children}
    </Component>
  ),
);

PageLayoutAside.displayName = "PageLayoutAside";

PageLayoutAside.propTypes = {
  sticky: PropTypes.bool,
  as: PropTypes.elementType,
  className: PropTypes.string,
  children: PropTypes.node,
};

const PageLayoutMain = React.forwardRef(
  ({ as: Component = "div", className, children, ...rest }, ref) => (
    <Component ref={ref} className={clsx(css.main, className)} {...rest}>
      {children}
    </Component>
  ),
);

PageLayoutMain.displayName = "PageLayoutMain";

PageLayoutMain.propTypes = {
  as: PropTypes.elementType,
  className: PropTypes.string,
  children: PropTypes.node,
};

const PageLayout = {
  Root: PageLayoutRoot,
  Aside: PageLayoutAside,
  Main: PageLayoutMain,
};

export default PageLayout;
